import { render, staticRenderFns } from "./TeacherTimelineCard.vue?vue&type=template&id=4b224d38&"
import script from "./TeacherTimelineCard.vue?vue&type=script&lang=js&"
export * from "./TeacherTimelineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports